export const APP_ALL = '[App] All';
export const APP_VERSION = '[App] Version';
